/**
 * Helper class to store clipboard data
 */

import type { SupportedEditorTypes } from '@/objects/Valueparsers/ComponentValueUtils';

/**
 * The Clipboard data item. This contains all the cells that were copied at one time
 */
export class ClipboardData {
    /**
     * The timestamp when the clipboard data was created
     * @remarks Used to expire old clipboard data after 60 seconds
     */
    public readonly timestamp: Date = new Date();

    /**
     * The items in the clipboard data
     */
    public items: ClipboardDataItem[];

    /**
     * A hash of the clipboard data for quick comparison
     */
    public readonly hash: string;

    constructor(items: ClipboardDataItem[]) {
        this.items = items;
        this.hash = this.items.map((i) => `${i.text}`).join('|');
    }
}

export class ClipboardDataItem {
    /**
     * The actual value of the cell that is copied
     */
    public value: any;

    /**
     * The text value is what is actually copied to the system clipboard
     */
    public text: string;

    /**
     * The editor type of the cell that is copied. This is used to convert the value back to the correct type when pasting into the grid
     * @remarks If null, then this comes from the system clipboard and we have no idea what editor type it is
     */
    public editorType: SupportedEditorTypes | null;

    /**
     * The column ID of the cell that is copied
     */
    public columnId?: string;

    /**
     * The row ID of the cell that is copied
     */
    public rowId?: any;

    constructor(text: string, value: any, editorType: SupportedEditorTypes | null, columnId?: string, rowId?: any) {
        this.text = text;
        this.value = value;
        this.columnId = columnId;
        this.rowId = rowId;
        this.editorType = editorType;
    }
}
